import { Pipe, PipeTransform } from '@angular/core'
import * as moment from 'moment'

@Pipe({ name: 'formatDateTime' })
export class FormatDateTimePipe implements PipeTransform {
    transform(value: any): string {
        return moment(value).format('DD MMM YYYY HH:mm')
    }
}
